var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_140_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M490.667 234.667H277.333V21.3333C277.333 15.6754 275.086 10.2492 271.085 6.24839C267.084 2.24761 261.658 0 256 0V0C250.342 0 244.916 2.24761 240.915 6.24839C236.914 10.2492 234.667 15.6754 234.667 21.3333V234.667H21.3333C15.6754 234.667 10.2492 236.914 6.24839 240.915C2.24761 244.916 0 250.342 0 256H0C0 261.658 2.24761 267.084 6.24839 271.085C10.2492 275.086 15.6754 277.333 21.3333 277.333H234.667V490.667C234.667 496.325 236.914 501.751 240.915 505.752C244.916 509.752 250.342 512 256 512C261.658 512 267.084 509.752 271.085 505.752C275.086 501.751 277.333 496.325 277.333 490.667V277.333H490.667C496.325 277.333 501.751 275.086 505.752 271.085C509.752 267.084 512 261.658 512 256C512 250.342 509.752 244.916 505.752 240.915C501.751 236.914 496.325 234.667 490.667 234.667Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_140_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 512,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.1045eeaa0c78f3dd980588895032f1ff.svg";
export { ForwardRef as ReactComponent };